// Verifica se il dispositivo è iOS
export const isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
}

// Verifica la pwa è installata sul dispositivo
export function pwaInstalled() {
    // Per iOS
    if (window.navigator.standalone) return true;

    // Per Android
    if (window.matchMedia("(display-mode: standalone)").matches) return true;

    // Se nessuna delle condizioni è vera, l'app non è installata
    return false;
}

/* eslint-disable no-undef */
export async function installPWA() {

    // Hide the app provided install promotion
    hideInstallPromotion();

    if (deferredPrompt != null) {
        // Show the install prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.userChoice;
        // // Optionally, send analytics event with outcome of user choice
        // console.log(`User response to the install prompt: ${outcome}`);
        // We've used the prompt and can't use it again, throw it away
        deferredPrompt = null;
    }

}

export function onClickInstallButton(functionSetState) {
    if(isIos() && functionSetState) {
        functionSetState(true);
      }
      else {
        installPWA();
      }
}

function hideInstallPromotion() {
    let buttonInstall = document.getElementById('installButton');
    if (buttonInstall != null && buttonInstall != undefined) {
        buttonInstall.style.display = 'none !important';
    }
}












// /* eslint-disable no-undef */
// export async function installPWA() {

//     // Hide the app provided install promotion
//     hideInstallPromotion();

//     if (deferredPrompt != null) {
//         // Show the install prompt
//         deferredPrompt.prompt();
//         // Wait for the user to respond to the prompt
//         const { outcome } = await deferredPrompt.userChoice;
//         // // Optionally, send analytics event with outcome of user choice
//         // console.log(`User response to the install prompt: ${outcome}`);
//         // We've used the prompt and can't use it again, throw it away
//         deferredPrompt = null;
//     }

// }

// function hideInstallPromotion() {
//     let buttonInstall = document.getElementById('installButton');
//     if (buttonInstall != null && buttonInstall != undefined){
//         buttonInstall.style.display = 'none !important';
//     }
// }

// export function pwaInstalled() {
//     console.log('pwaInsatalled: ');
//     console.log(deferredPrompt === null);
//     console.log(deferredPrompt);

//     var check = function () {
//         setTimeout(check, 1000);
//     }
//     check();

//     return (deferredPrompt === null);
// }

// // // Names of the two caches used in this version of the service worker.
// // // Change to v2, etc. when you update any of the local resources, which will
// // // in turn trigger the install event again.
// // const PRECACHE = 'precache-v1.01';
// // const RUNTIME = 'runtime';

// // // A list of local resources we always want to be cached.
// // const PRECACHE_URLS = [
// //   // 'index.html',
// //   // './', // Alias for index.html
// //   // 'index.css',
// //   // '..\src\App.css',
// //   // '..\src\App.tsx'
// // ];

// // // The install handler takes care of precaching the resources we always need.
// // self.addEventListener('install', event => {
// //   event.waitUntil(
// //     caches.open(PRECACHE)
// //       .then(cache => cache.addAll(PRECACHE_URLS))
// //       .then(self.skipWaiting())
// //   );
// // });

// // // The activate handler takes care of cleaning up old caches.
// // self.addEventListener('activate', event => {
// //   const currentCaches = [PRECACHE, RUNTIME];
// //   event.waitUntil(
// //     caches.keys().then(cacheNames => {
// //       return cacheNames.filter(cacheName => !currentCaches.includes(cacheName));
// //     }).then(cachesToDelete => {
// //       return Promise.all(cachesToDelete.map(cacheToDelete => {
// //         return caches.delete(cacheToDelete);
// //       }));
// //     }).then(() => self.clients.claim())
// //   );
// // });

// // // The fetch handler serves responses for same-origin resources from a cache.
// // // If no response is found, it populates the runtime cache with the response
// // // from the network before returning it to the page.
// // self.addEventListener('fetch', event => {
// //   // Skip cross-origin requests, like those for Google Analytics.
// //   if (event.request.url.startsWith(self.location.origin)) {
// //     event.respondWith(
// //       caches.match(event.request).then(cachedResponse => {
// //         if (cachedResponse) {
// //           return cachedResponse;
// //         }

// //         return caches.open(RUNTIME).then(cache => {
// //           return fetch(event.request).then(response => {
// //             // Put a copy of the response in the runtime cache.
// //             return cache.put(event.request, response.clone()).then(() => {
// //               return response;
// //             });
// //           });
// //         });
// //       })
// //     );
// //   }
// // });


// /* eslint-disable */
// // This optional code is used to register a service worker.
// // register() is not called by default.

// // This lets the app load faster on subsequent visits in production, and gives
// // it offline capabilities. However, it also means that developers (and users)
// // will only see deployed updates on subsequent visits to a page, after all the
// // existing tabs open on the page have been closed, since previously cached
// // resources are updated in the background.

// // To learn more about the benefits of this model and instructions on how to
// // opt-in, read https://bit.ly/CRA-PWA

// const isLocalhost = Boolean(window.location.hostname === 'localhost' ||
//     // [::1] is the IPv6 localhost address.
//     window.location.hostname === '[::1]' ||
//     // 127.0.0.0/8 are considered localhost for IPv4.
//     window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));

// export function register(config) {
//   if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
//     // The URL constructor is available in all browsers that support SW.
//     const publicUrl = new URL(process.env.REACT_APP_BASE_URL, window.location.href);
//     if (publicUrl.origin !== window.location.origin) {
//       // Our service worker won't work if REACT_APP_BASE_URL is on a different origin
//       // from what our page is served on. This might happen if a CDN is used to
//       // serve assets; see https://github.com/facebook/create-react-app/issues/2374
//       return;
//     }

//     window.addEventListener('load', () => {
//       const swUrl = `${process.env.REACT_APP_BASE_URL}/sw.js`;

//       if (isLocalhost) {
//         // This is running on localhost. Let's check if a service worker still exists or not.
//         checkValidServiceWorker(swUrl, config);

//         // Add some additional logging to localhost, pointing developers to the
//         // service worker/PWA documentation.
//         navigator.serviceWorker.ready.then(() => {
//           console.log('This web app is being served cache-first by a service ' +
//               'worker. To learn more, visit https://bit.ly/CRA-PWA');
//         });
//       } else {
//         // Is not localhost. Just register service worker
//         registerValidSW(swUrl, config);
//       }
//     });
//   }
// }

// function registerValidSW(swUrl, config) {
//   navigator.serviceWorker
//     .register(swUrl)
//     .then((registration) => {
//       registration.onupdatefound = () => {
//         const installingWorker = registration.installing;
//         if (installingWorker == null) {
//           return;
//         }
//         installingWorker.onstatechange = () => {
//           if (installingWorker.state === 'installed') {
//             if (navigator.serviceWorker.controller) {
//               // At this point, the updated precached content has been fetched,
//               // but the previous service worker will still serve the older
//               // content until all client tabs are closed.
//               console.log('New content is available and will be used when all ' +
//                   'tabs for this page are closed. See https://bit.ly/CRA-PWA.');

//               // Execute callback
//               if (config && config.onUpdate) {
//                 config.onUpdate(registration);
//               }
//             } else {
//               // At this point, everything has been precached.
//               // It's the perfect time to display a
//               // "Content is cached for offline use." message.
//               console.log('Content is cached for offline use.');

//               // Execute callback
//               if (config && config.onSuccess) {
//                 config.onSuccess(registration);
//               }
//             }
//           }
//         };
//       };
//     })
//     .catch((error) => {
//       console.error('Error during service worker registration:', error);
//     });
// }

// function checkValidServiceWorker(swUrl, config) {
//   // Check if the service worker can be found. If it can't reload the page.
//   fetch(swUrl, {
//     headers: { 'Service-Worker': 'script' },
//   })
//     .then((response) => {
//       // Ensure service worker exists, and that we really are getting a JS file.
//       const contentType = response.headers.get('content-type');
//       if (
//         response.status === 404 ||
//         (contentType != null && contentType.indexOf('javascript') === -1)
//       ) {
//         // No service worker found. Probably a different app. Reload the page.
//         navigator.serviceWorker.ready.then((registration) => {
//           registration.unregister().then(() => {
//             window.location.reload();
//           });
//         });
//       } else {
//         // Service worker found. Proceed as normal.
//         registerValidSW(swUrl, config);
//       }
//     })
//     .catch(() => {
//       console.log('No internet connection found. App is running in offline mode.');
//     });
// }

// export function unregister() {
//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.ready
//       .then((registration) => {
//         registration.unregister();
//       })
//       .catch((error) => {
//         console.error(error.message);
//       });
//   }
// }